import apiClient from "./client";
import type {
  DisasterIdParam,
  GetDisasterExcelParams,
} from "../types/disaster";

export const getDisasterExcel = async (
  disasterId: DisasterIdParam,
  params: GetDisasterExcelParams
): Promise<Blob> => {
  const { data } = await apiClient.get<Blob>(`/disaster-excel/${disasterId}`, {
    params: {
      is_meti: params.is_meti,
    },
    responseType: "blob",
  });
  return data;
};
